import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const transactionApi = createApi({
  reducerPath: 'transaction',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['Transaction'],
  endpoints: (builder) => ({
    getTransactions: builder.query({
      // keepUnusedDataFor: 0,
      query: ({ pageno, limit, sortOrder, sortBy, status, search }) => {
        const currentPage = pageno || 1;
        let url = `contractor/transactions?pageno=${currentPage}`;

        if (limit) {
          url += `&limit=${limit}`;
        }

        if (search) {
          url += `&search=${search}`;
        }

        if (status) {
          url += `&status=${status}`;
        }

        if (sortOrder) {
          url += `&sortOrder=${sortOrder}`;
        }

        if (sortBy) {
          url += `&sortBy=${sortBy}`;
        }

        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['Transaction'],
    }),
    linkTransactionToInvoice: builder.mutation({
      query: ({ transactionId, invoiceId, clientId }) => ({
        url: `contractor/transaction/${transactionId}/invoice`,
        method: 'PUT',
        body: {
          invoice_id: invoiceId,
          client_id: clientId,
        },
      }),
      invalidatesTags: ['Transaction'],
    }),
    getTransactionById: builder.query({
      query: (id) => ({
        url: `contractor/transaction/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Transaction', id }],
    }),
    createTransactionRefund: builder.mutation({
      query: ({ transactionId, full_refund, amount }) => ({
        url: `contractor/transaction/${transactionId}/refund`,
        method: 'POST',
        body: { full_refund, ...(full_refund ? {} : { amount }) },
      }),
      invalidatesTags: ['Transaction'],
    }),
  }),
});

export const {
  useGetTransactionsQuery,
  useGetTransactionByIdQuery,
  useLinkTransactionToInvoiceMutation,
  useCreateTransactionRefundMutation,
} = transactionApi;